import { MoipCreditCard } from 'moip-sdk-js'
import { removeMask } from './removeMask'

interface IHashCard {
  cardNumber: string
  cvc: string
  expirationDate: string
}

const WIRECARD_PUB_KEY =
  process.env.NEXT_PUBLIC_API_ENV === 'production'
    ? process.env.NEXT_PUBLIC_WIRECARD_KEY_PROD
    : process.env.NEXT_PUBLIC_WIRECARD_KEY_DEV

export const hashCard = async ({ cardNumber, cvc, expirationDate }: IHashCard): Promise<string> => {
  try {
    if (typeof window !== 'undefined') {
      const month = expirationDate.split('/')[0] || ''
      const year = expirationDate.split('/')[1] || ''

      const JSEncrypter = (await import('jsencrypt')).default
      const hashedCard = await MoipCreditCard.setEncrypter(JSEncrypter, 'js')
        .setPubKey(WIRECARD_PUB_KEY)
        .setCreditCard({
          number: removeMask(cardNumber),
          cvc,
          expirationMonth: month,
          expirationYear: year,
        })
        .hash()
      return hashedCard
    }

    return ''
  } catch (error) {
    process.env.NEXT_PUBLIC_API_ENV === 'staging' && console.log('error', error)
    return 'Ocorreu um erro inesperado'
  }
}
